import { render, staticRenderFns } from "./GiftDetail.vue?vue&type=template&id=da69cf0a&scoped=true"
import script from "./GiftDetail.vue?vue&type=script&lang=js"
export * from "./GiftDetail.vue?vue&type=script&lang=js"
import style0 from "./GiftDetail.vue?vue&type=style&index=0&id=da69cf0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da69cf0a",
  null
  
)

export default component.exports